import React from 'react';
import { CheckIcon, GlobeIcon, LockIcon, FlameIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { Countdown } from './Countdown';
import { images } from '../data/checkout';
const stack = [{
  title: 'The Six-Volume Collection',
  text: 'Assessment, metabolic and comorbidity reviews, treatment planning, complex cases, treatment reassessment, and long-term care.',
  value: 79
}, {
  title: 'Five Specialized Clinical Tools',
  text: 'Assessment Worksheet, Comorbidity Review Matrix, Consultation Planner, Treatment Review Tracker, and Long-Term Care Checklist.',
  value: 87
}];
const SPOTS_TOTAL = 100;
const SPOTS_LEFT = 7;
export function Offer() {
  const filled = (SPOTS_TOTAL - SPOTS_LEFT) / SPOTS_TOTAL * 100;
  return <section id="offer" className="bg-brand-deep px-4 py-16 text-white sm:px-6 md:py-24" data-id="element-171" data-mp="2fbxxj64v4fbj">
      <div className="mx-auto max-w-5xl" data-id="element-172" data-mp="2ad3d5zr8yipb">
        <div className="mx-auto max-w-3xl text-center" data-id="element-173" data-mp="2acbhyq1kamzk">
          <h2 className="font-serif text-[32px] font-bold leading-[1.12] sm:text-4xl md:text-5xl" data-id="element-174" data-mp="pkh73cmdaygq">
            What if you could organize your obesity care references in one place?
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-white/80" data-id="element-175" data-mp="zierfp13wb42">
            One purchase. Six volumes. Five specialized tools. One structured reference system.
          </p>
        </div>

        <div className="mx-auto mt-10 max-w-2xl overflow-hidden rounded-3xl bg-white text-ink shadow-2xl" data-id="element-176" data-mp="6tpqpr3yq7su">
          <div className="bg-gold px-5 py-3 text-center text-sm font-extrabold uppercase tracking-wider text-ink" data-id="element-177" data-mp="bskj9krqfaq5">
            Your special launch offer
          </div>

          <div className="px-5 pb-8 pt-6 sm:px-9" data-id="element-178" data-mp="fsb3t6qo0um8">
            <img src={images.hero} alt="Obesity Clinical Blueprint™ complete collection" className="mx-auto w-full max-w-md" data-id="element-179" data-mp="kldzplix0g5l" />

            <ul className="mt-6 divide-y divide-line" data-id="element-180" data-mp="3k846o35q1yxa">
              {stack.map(item => <li key={item.title} className="flex gap-3 py-4" data-id="element-181" data-mp="3o8o4l8y4d6kh">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-cta text-white" data-id="element-182" data-mp="vf7h2qwxeygt">
                    <CheckIcon className="h-4 w-4" strokeWidth={3} aria-hidden="true" data-id="element-183" data-mp="qfutg3y8dnd6" />
                  </span>
                  <div className="flex-1" data-id="element-184" data-mp="1550m192kcfc3">
                    <div className="flex items-baseline justify-between gap-3" data-id="element-185" data-mp="106pfp8bh8mym">
                      <h3 className="font-bold leading-snug" data-id="element-186" data-mp="108ti1ltq9dws">{item.title}</h3>
                      <s className="shrink-0 text-[15px] font-semibold text-muted" data-id="element-187" data-mp="ch4tmgk119l4">${item.value}</s>
                    </div>
                    <p className="mt-1 text-[15px] leading-relaxed text-muted" data-id="element-188" data-mp="lhkwbnsy4cox">{item.text}</p>
                  </div>
                </li>)}
            </ul>

            <div className="mt-2 rounded-2xl bg-canvas px-5 py-6 text-center" data-id="element-189" data-mp="heo7vggq5md2">
              <p className="text-[16px] font-semibold text-muted" data-id="element-190" data-mp="1wvewevbdb9j0">
                Total reference value: <s className="text-alarm" data-id="element-191" data-mp="1su35mmgrci98">$166</s>
              </p>
              <p className="mt-2 text-[16px] font-semibold text-ink" data-id="element-192" data-mp="20ex9k5bkvzw5">Get the complete collection today for just:</p>
              <p className="mt-1 font-serif text-7xl font-bold leading-none text-cta-dark sm:text-8xl" data-id="element-193" data-mp="25e9x6sa9xazs">
                $27
                <span className="ml-2 align-top font-sans text-xl font-extrabold text-ink" data-id="element-194" data-mp="1qhrgirjelyta">USD</span>
              </p>
              <p className="mt-2 text-sm font-bold uppercase tracking-wider text-ink" data-id="element-195" data-mp="1vfsz7bcx3w48">One-Time Payment</p>
              <ul className="mt-4 space-y-1 text-[15px] text-muted" data-id="element-196" data-mp="2j787rlvaf9nx">
                <li data-id="element-197" data-mp="2o2wyr0t8ri8m">No recurring subscription fees</li>
                <li data-id="element-198" data-mp="29fbz5gvks15g">Instant digital delivery</li>
                <li data-id="element-199" data-mp="29ek8mkgu4tm1">Access to the edition you purchase</li>
              </ul>
            </div>

            <div className="mt-5 flex items-start gap-3 rounded-2xl border border-brand/20 bg-brand-soft p-4" data-id="element-200" data-mp="2ed3xotqq6lim">
              <GlobeIcon className="mt-0.5 h-5 w-5 shrink-0 text-brand" aria-hidden="true" data-id="element-201" data-mp="322g8fy1pb1n1" />
              <p className="text-[15px] leading-relaxed text-ink" data-id="element-202" data-mp="36walwjqpqkdo">
                <strong data-id="element-203" data-mp="1j6o84kjpbm8q">Automatic currency conversion:</strong> the price is converted to your local currency
                automatically at checkout.
              </p>
            </div>

            <div className="mt-6" aria-label={`Only ${SPOTS_LEFT} spots left at the promotional price`} data-id="element-204" data-mp="197yrev3jk7u2">
              <div className="flex items-center justify-between gap-3 text-[15px] font-bold" data-id="element-205" data-mp="149nda867rb61">
                <span className="flex items-center gap-1.5 text-alarm" data-id="element-206" data-mp="21xfct8squogs">
                  <FlameIcon className="h-4 w-4" aria-hidden="true" data-id="element-207" data-mp="21yqff5agdq6b" />
                  Only {SPOTS_LEFT} spots left at $27
                </span>
                <span className="text-muted" data-id="element-208" data-mp="1s617uli0wwg9">{Math.round(filled)}% claimed</span>
              </div>
              <div className="mt-2 h-4 w-full overflow-hidden rounded-full bg-alarm/10" data-id="element-209" data-mp="1n6ye3x7hucnl">
                <div className="relative h-full rounded-full bg-alarm" style={{
                width: `${filled}%`
              }} data-id="element-210" data-mp="2knna3a9rikp2">
                  <span className="animate-live absolute right-1 top-1/2 h-2 w-2 -translate-y-1/2 rounded-full bg-white" data-id="element-211" data-mp="2fuu7arxutmfm" />
                </div>
              </div>
              <p className="mt-2 text-sm text-muted" data-id="element-212" data-mp="2s7o6vr1ppatb">
                When the promotional spots run out, the price returns to its regular value.
              </p>
            </div>

            <div className="mt-7" data-id="element-213" data-mp="3263xzu0qok2t">
              <CTAButton label="Yes, I want Obesity Clinical Blueprint™" note="$27 USD · One-Time Payment · 7-Day Money-Back Guarantee" data-id="element-214" data-mp="326dqppd655c7" />
            </div>

            <Countdown data-id="element-215" data-mp="3b3o0t7e92ofj" />

            <p className="mt-6 flex items-center justify-center gap-2 text-sm text-muted" data-id="element-216" data-mp="3fwh3lpq5rmoz">
              <LockIcon className="h-4 w-4" aria-hidden="true" data-id="element-217" data-mp="3kvkc5k5ckb1p" />
              Secure checkout · The price is charged in the currency shown at checkout.
            </p>
          </div>
        </div>
      </div>
    </section>;
}